import { render } from "./GroupSystemHealthReport.vue?vue&type=template&id=419a71f3"
import script from "./GroupSystemHealthReport.vue?vue&type=script&lang=js"
export * from "./GroupSystemHealthReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__